/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';

import { Select } from '@atoms';
import { ARTICLE_LAYOUTS } from '@api/articles/constants';
import { NARROW_COL } from '@constants';

import Form from '../Form';

const ArticleLayoutField = (props) => (
  <Form.Item wrapperCol={NARROW_COL} {...props}>
    <Select placeholder="- Choose an article layout -">
      {ARTICLE_LAYOUTS.map(({ key, label }) => (
        <Select.Option key={key} value={key}>
          {label}
        </Select.Option>
      ))}
    </Select>
  </Form.Item>
);

export default ArticleLayoutField;
